// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__XUIQb","title":"ClientCherryInfo_title__3HCVN","itemText":"ClientCherryInfo_itemText__sPM0i"};